const o = "_section_45jvg_1", p = "_wrapper_45jvg_4", r = "_logoWrapper_45jvg_8", e = "_logo_45jvg_8", _ = {
  section: o,
  wrapper: p,
  logoWrapper: r,
  logo: e
};
export {
  _ as default,
  e as logo,
  r as logoWrapper,
  o as section,
  p as wrapper
};
